import { LineColorAPI } from '../../../api/datamanager/LineColorAPI';

export class LineColorsCommand {
    getAll(provider, successCallback, errorCallback) {
        let apiResult = LineColorAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Cores das Linhas");
            }
        });
    }
}
